import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: refactor this file, right now this is essentially a straight port from the previous implementation

export enum ActionType {
  LINK = 'link',
  VIEW = 'view'
}

export const pageViews = {
  checkoutOPC: ActionType.VIEW
};

const defaultData: IDataLayer = {
  cartOverlay: {
    enh_action: 'checkout',
    active_checkout_panel: 'cart',
    checkout_type: 'react',
    event_name: 'checkout_basket',
    event_category: 'ecommerce',
    event_action: 'view_cart',
    event_label: 'view_cart_overlay',
    event_noninteraction: 'true',
    event_cart_overlay: 'Cart Overlay'
  },

  oneClickcheckout: {
    enh_action: 'checkout',
    checkout_type: 'oneclick',
    event_name: 'checkout_option',
    event_category: 'cart',
    event_action: 'view',
    event_label: location.pathname,
    event_one_click: 'one click'
  },

  checkoutSampleAdded: {
    event_name: 'cart_sample_added',
    event_category: 'viewcart',
    event_action: 'cart_sample_added',
    event_label: null // <sample name - SKU ID - sample category>
  },

  checkoutSampleRemoved: {
    event_name: 'cart_sample_removed',
    event_category: 'viewcart',
    event_action: 'cart_sample_removed',
    event_label: null // <sample name - SKU ID - sample category>
  },

  checkoutPaymentSelected: {
    event_name: 'payment_selected',
    page_name: 'checkout | payment',
    enh_action: 'checkout',
    event_category: 'ecommerce',
    event_action: 'checkout option',
    event_label: null, // 'creditcard of paypal'
    event_value: '0'
  },

  checkoutGuestUser: {
    enh_action: 'checkout_option',
    event_name: 'guest_checkout',
    event_category: 'ecommerce',
    event_action: 'checkout option',
    event_value: '0',
    event_label: 'guest checkout'
  },

  checkoutOPC: {
    enh_action: 'checkout',
    event_label: null, // <panel name>
    page_name: null, // <panel name>
    page_type: null // <page_type>
  },

  checkoutReturnUser: {
    enh_action: 'checkout_option',
    event_name: 'return_user_checkout',
    event_category: 'ecommerce',
    event_action: 'checkout option',
    event_value: '0',
    event_label: 'return checkout'
  }
};

function trackCheckout(eventName: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};

  // TODO: maybe split this out so as not to have all these conditionals
  // right now this just has the logic ported from the old analytics file
  // should also optimize for vulcan

  if (eventName === 'checkoutOPC') {
    if (data && data.active_checkout_panel && data.active_checkout_panel === 'viewcart') {
      return;
    }
    // OPC will pass two active_panels for each event: 'review' and the current panel
    // So pop the first panel, if not review, use it. Otherwise check the second.
    eventData.event_label =
      typeof eventData.active_panel === 'object'
        ? eventData.active_panel[0] === 'review'
          ? eventData.active_panel[1]
          : eventData.active_panel[0]
        : eventData.active_panel;
    eventData.page_name = 'checkout | ' + eventData.event_label;
    eventData.page_type = data.page_type;
  } else if (eventName === 'checkoutSampleAdded') {
    eventData.event_label = '';
    for (let i = 0; i < eventData.sample_product_name?.length || 0; i++) {
      eventData.event_label = `${eventData.event_label}${eventData.sample_product_name[i]} - SKU${eventData.sample_product_category_id[i]}`;
    }
    tealium.evtLink({ ...defaultData[eventName], ...eventData });
    return;
  } else if (eventName === 'checkoutSampleRemoved') {
    eventData.event_label = eventData.cart_Sample;
    tealium.evtLink({ ...defaultData[eventName], ...eventData });
    return;
  } else if (eventName === 'oneClickcheckout') {
    eventData.location = '/checkout/onecart.tmpl';
    tealium.evtLink({ ...data, ...defaultData[eventName], ...eventData });
    return;
  } else if (eventName === 'checkoutPaymentSelected') {
    tealium.evtLink({ ...data, ...defaultData[eventName], ...eventData });
    return;
  }

  // TODO: should we always pass through the datalayer? should this be something that is automatically done in the data layer module?

  if (pageViews[eventName] == ActionType.VIEW) {
    tealium.evtView({ ...defaultData[eventName], ...eventData });
  } else {
    tealium.evtLink({ ...defaultData[eventName], ...eventData });
  }
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackCheckout);
});
